var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRank1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M35.7168 14.8463C37.4586 24.6309 30.9399 33.9768 21.1529 35.7186C19.8155 35.9567 18.4872 36.0407 17.1841 35.982C15.5466 35.9102 13.9508 35.6134 12.4332 35.1184C11.0788 34.6773 9.78629 34.0763 8.58268 33.3367C8.21491 33.1108 7.85448 32.8718 7.50384 32.6191C5.96264 31.5133 4.59595 30.1654 3.4641 28.6185C3.24311 28.3167 3.03027 28.0069 2.82886 27.6905C1.59182 25.757 0.707061 23.5529 0.279764 21.1538C0.240623 20.9345 0.206368 20.7143 0.177012 20.4933C-1.16685 10.9517 5.27848 1.98419 14.8437 0.281531C17.1979 -0.137611 19.526 -0.0780926 21.7286 0.389161C22.1542 0.479676 22.575 0.58487 22.9909 0.705556C24.8061 1.23071 26.5185 2.03719 28.0671 3.08423C28.4088 3.31501 28.7415 3.55638 29.0668 3.80998C30.2231 4.71106 31.2702 5.7532 32.181 6.91685C33.1196 8.11638 33.913 9.44557 34.5303 10.8816C34.9805 11.9302 35.3368 13.036 35.5855 14.1907C35.6353 14.4084 35.6785 14.6269 35.7168 14.8463Z",
    fill: "url(#paint0_linear_1_6981)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M34.531 10.8807L17.1839 35.9811C15.5465 35.9094 13.9507 35.6126 12.4331 35.1176L32.1817 6.91602C33.1211 8.11554 33.9145 9.44473 34.531 10.8807Z",
    fill: "#F2F0F3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M22.9916 0.705067L3.46483 28.6188C3.24384 28.3171 3.03101 28.0072 2.82959 27.6908L21.7293 0.388672C22.155 0.479187 22.5757 0.584381 22.9916 0.705067Z",
    fill: "#F2F0F3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M29.0677 3.80974L8.58275 33.3372C8.21498 33.1113 7.85455 32.8724 7.50391 32.6196L28.0671 3.08398C28.4096 3.31476 28.7423 3.55613 29.0677 3.80974Z",
    fill: "#F2F0F3"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M32.161 15.48C32.2001 15.6969 32.2327 15.9154 32.2629 16.1323C33.2578 23.7022 28.1123 30.8113 20.5204 32.1625C12.9286 33.5137 5.64579 28.6169 3.96759 21.1694C3.92111 20.9549 3.87708 20.7388 3.83794 20.5219C2.44759 12.7132 7.66974 5.22977 15.4785 3.83943C23.2873 2.44908 30.7706 7.67043 32.161 15.48Z",
    fill: "url(#paint1_linear_1_6981)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M32.2623 16.134C33.2572 23.7039 28.1117 30.813 20.5198 32.1642C20.3502 32.1943 20.1814 32.2204 20.0126 32.2441C18.3084 32.4863 16.6269 32.417 15.0245 32.0761C13.423 31.7352 11.9038 31.1253 10.5265 30.2854C10.1767 30.0725 9.83662 29.8458 9.50392 29.6028C7.9986 28.4987 6.70285 27.1067 5.71534 25.4848C5.47722 25.0975 5.25624 24.6938 5.05645 24.2812C4.58104 23.3076 4.21409 22.2662 3.96619 21.1711C2.97134 13.6012 8.11684 6.49051 15.7087 5.13931C16.6693 4.96807 17.625 4.89793 18.5668 4.91995C19.0455 4.93055 19.5225 4.96562 19.9939 5.02433C21.9175 5.26326 23.7499 5.8887 25.3922 6.83381C25.7461 7.03767 26.0935 7.25703 26.431 7.49269C27.7407 8.40111 28.9011 9.52562 29.8519 10.8263C30.779 12.0943 31.5064 13.5262 31.9843 15.0862C32.0903 15.4287 32.1832 15.7793 32.2623 16.134Z",
    fill: "url(#paint2_linear_1_6981)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M13.0205 13.0845C14.3571 12.428 15.4131 12.0521 17.1249 10.0117H21.3001V23.287H23.4816V26.4071H14.0986V23.287H16.4447V14.5858L14.0986 15.6883L13.0205 13.0845Z",
    fill: "url(#paint3_linear_1_6981)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_7"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M13.0205 12.1567C14.3571 11.5003 15.4131 11.1243 17.1249 9.08398H21.3001V22.3593H23.4816V25.4793H14.0986V22.3593H16.4447V13.6572L14.0986 14.7598L13.0205 12.1567Z",
    fill: "url(#paint4_linear_1_6981)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_8",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M31.9854 15.0851L20.0132 32.243C18.3089 32.4852 16.6273 32.4159 15.0249 32.075L29.8529 10.8242C30.7801 12.0931 31.5075 13.5243 31.9854 15.0851Z",
    fill: "url(#paint5_linear_1_6981)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M19.9947 5.02121L5.71555 25.4826C5.47743 25.0952 5.25643 24.6916 5.05664 24.2789L18.5676 4.91602C19.0463 4.92743 19.5234 4.9625 19.9947 5.02121Z",
    fill: "url(#paint6_linear_1_6981)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M26.4315 7.49287L10.527 30.2864C10.1771 30.0735 9.8371 29.8468 9.50439 29.6038L25.3927 6.83398C25.7466 7.03785 26.0939 7.2572 26.4315 7.49287Z",
    fill: "url(#paint7_linear_1_6981)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_6981",
    x1: 17.9997,
    y1: 19.3093,
    x2: 17.9997,
    y2: 67.3717,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD540"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FC9E00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1_6981",
    x1: 3.61385,
    y1: 18.0008,
    x2: 32.3859,
    y2: 18.0008,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FC9E00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DC7000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1_6981",
    x1: 19.3638,
    y1: 3.52406,
    x2: 17.5837,
    y2: 25.083,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD540"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FC9E00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1_6981",
    x1: 18.2509,
    y1: 11.9162,
    x2: 18.2509,
    y2: 25.5609,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FC9E00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DC7000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1_6981",
    x1: 18.2509,
    y1: 23.0242,
    x2: 18.2509,
    y2: 49.7997,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD540"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FC9E00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1_6981",
    x1: 23.5052,
    y1: 19.3094,
    x2: 23.5052,
    y2: 67.374,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD540"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FC9E00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1_6981",
    x1: 12.526,
    y1: 19.3085,
    x2: 12.526,
    y2: 67.3731,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD540"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FC9E00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_1_6981",
    x1: 17.9681,
    y1: 19.3112,
    x2: 17.9681,
    y2: 67.3737,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD540"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FC9E00"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRank1);
export default __webpack_public_path__ + "static/media/rank-1.28b83265d0016b8b75967e52f11d5a56.svg";
export { ForwardRef as ReactComponent };